import styled from 'styled-components';

export const Container = styled.div`
  padding: 20px 25px;
  width: 400px;
  box-sizing: border-box;
`;

export const Description = styled.div`
  margin-top: 20px;
`;

export const EmailExtraction = styled.div`
  margin: 0 10px;
`;

export const Cancel = styled.span`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

export const Footer = styled.div`
  display: flex;
`;
